import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/services/utils.service';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { AppConfigService } from 'src/app/common/services/app-config.service';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  resetPassword: any;

  constructor(private authService: AuthService,
    private utils: Utils,
    private fb: FormBuilder,
    private httpService: HttpRequestService,
    private appConfigService: AppConfigService) { }

  onPwdReset(form) {
    let requestData = {
      'workFlowName': 'CoreAdminService',
      'processType': 'Screen',
      'workFlowParams': JSON.stringify({
        'methodName': 'validateUserPassword',
        'processType': 'forgotpassword',
        ...form
      })
    };
    this.httpService.getFenceDetails(requestData)
      .subscribe((response) => {
        const currentUser = this.authService.getLoggedUserDetails();
        if (currentUser) {
          this.authService.setUserDetails(response['hdrcache'][0]);
        }
      });
  }

  ngOnInit() {
    this.resetPassword = this.fb.group({
      strUserId: ['', Validators.required]
    });
  }
}
